// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessagesComponent-module__messagesBox--ROo8l {
    display: flex;
    flex-direction: column-reverse;
    margin: 20px;
    gap: 15px;
    align-items: flex-start;
    max-height: 360px;
    overflow-y: auto;
    padding-bottom: 20px;
}

.MessagesComponent-module__message--nN4H9 {
    display: flex;
    flex-direction: column;
    background-color: rgb(209 209 245 / 25%);
    border-radius: 15px;
    padding: 15px;
    max-width: 70%;
    min-width: 50%;
}

.MessagesComponent-module__outgoing--Ucms9 {
    align-self: flex-end;
    background-color: rgb(207 234 255 / 50%);
}

.MessagesComponent-module__incoming--ZmNJs {
    align-self: flex-start;
}

.MessagesComponent-module__unreadMessage--wh8eN {
    background-color: rgb(251 148 148 / 11%);
}

.MessagesComponent-module__messageData--_MJ8u {
    display: flex;
    font-size: 12px;
    font-weight: bold;
    margin: 0;
    justify-content: flex-end;
    color: #0054E6;
    align-items: center;
    gap: 10px;
}

.MessagesComponent-module__messagePerson--wqElP {
    display: flex;
    font-size: 14px;
    color: #0054E6;
    margin: 0;
    align-items: center;
    gap: 10px;
}

.MessagesComponent-module__messageText--A25Tx {
    margin: 5px;
}

.MessagesComponent-module__formMessage--ulqTB {
    border-radius: 14px;
    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    min-height: 50px;
    padding: 20px;
}

.MessagesComponent-module__inputBox--ZQEgi {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: center;
}

.MessagesComponent-module__successText--gH62q {
    display: flex;
    color: green;
    justify-content: center;
}

.MessagesComponent-module__emptyBox--byyZ6 {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
}

.MessagesComponent-module__emptyBox--byyZ6>p {
    font-size: 16px;
    color: #6f879c70;
    font-weight: 500;
}

.MessagesComponent-module__readBtnBox--ccsrr {
    display: flex;
    justify-content: end;
}

.MessagesComponent-module__messageFiles--L5hQg {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/features/task/ui/MessagesComponent.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,2DAA2D;IAC3D,wDAAwD;IACxD,mDAAmD;IACnD,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB","sourcesContent":[".messagesBox {\r\n    display: flex;\r\n    flex-direction: column-reverse;\r\n    margin: 20px;\r\n    gap: 15px;\r\n    align-items: flex-start;\r\n    max-height: 360px;\r\n    overflow-y: auto;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.message {\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: rgb(209 209 245 / 25%);\r\n    border-radius: 15px;\r\n    padding: 15px;\r\n    max-width: 70%;\r\n    min-width: 50%;\r\n}\r\n\r\n.outgoing {\r\n    align-self: flex-end;\r\n    background-color: rgb(207 234 255 / 50%);\r\n}\r\n\r\n.incoming {\r\n    align-self: flex-start;\r\n}\r\n\r\n.unreadMessage {\r\n    background-color: rgb(251 148 148 / 11%);\r\n}\r\n\r\n.messageData {\r\n    display: flex;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n    justify-content: flex-end;\r\n    color: #0054E6;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.messagePerson {\r\n    display: flex;\r\n    font-size: 14px;\r\n    color: #0054E6;\r\n    margin: 0;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.messageText {\r\n    margin: 5px;\r\n}\r\n\r\n.formMessage {\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    min-height: 50px;\r\n    padding: 20px;\r\n}\r\n\r\n.inputBox {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 10px;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.successText {\r\n    display: flex;\r\n    color: green;\r\n    justify-content: center;\r\n}\r\n\r\n.emptyBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.emptyBox>p {\r\n    font-size: 16px;\r\n    color: #6f879c70;\r\n    font-weight: 500;\r\n}\r\n\r\n.readBtnBox {\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n\r\n.messageFiles {\r\n    display: flex;\r\n    gap: 20px;\r\n    flex-wrap: wrap;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messagesBox": `MessagesComponent-module__messagesBox--ROo8l`,
	"message": `MessagesComponent-module__message--nN4H9`,
	"outgoing": `MessagesComponent-module__outgoing--Ucms9`,
	"incoming": `MessagesComponent-module__incoming--ZmNJs`,
	"unreadMessage": `MessagesComponent-module__unreadMessage--wh8eN`,
	"messageData": `MessagesComponent-module__messageData--_MJ8u`,
	"messagePerson": `MessagesComponent-module__messagePerson--wqElP`,
	"messageText": `MessagesComponent-module__messageText--A25Tx`,
	"formMessage": `MessagesComponent-module__formMessage--ulqTB`,
	"inputBox": `MessagesComponent-module__inputBox--ZQEgi`,
	"successText": `MessagesComponent-module__successText--gH62q`,
	"emptyBox": `MessagesComponent-module__emptyBox--byyZ6`,
	"readBtnBox": `MessagesComponent-module__readBtnBox--ccsrr`,
	"messageFiles": `MessagesComponent-module__messageFiles--L5hQg`
};
export default ___CSS_LOADER_EXPORT___;
